import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navbar } from "./components/sections/Navbar";
import { Hero } from "./components/sections/Hero";
import { Problema } from "./components/sections/Problema";
import { ComoFunciona } from "./components/sections/ComoFunciona";
import { Resultados } from "./components/sections/Resultados";
import { SobreAitor } from "./components/sections/SobreAitor";
import { Servicios } from "./components/sections/Servicios";
import { FAQ } from "./components/sections/FAQ";
import { CTAFinal } from "./components/sections/CTAFinal";
import { FloatingWhatsApp } from "./components/sections/FloatingWhatsApp";
import { Footer } from "./components/sections/Footer";
import AvisoLegal from "./pages/AvisoLegal";
import PoliticaPrivacidad from "./pages/PoliticaPrivacidad";

const Landing = () => {
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white" data-testid="landing-root">
      <Navbar />
      <main>
        <Hero />
        <Problema />
        <ComoFunciona />
        <Resultados />
        <SobreAitor />
        <Servicios />
        <FAQ />
        <CTAFinal />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
};

const LegalPage = ({ children }) => (
  <div className="min-h-screen bg-[#0A0A0A] text-white">
    {children}
    <Footer />
    <FloatingWhatsApp />
  </div>
);

function App() {
  return (
    <div className="App dark">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route
            path="/aviso-legal"
            element={
              <LegalPage>
                <AvisoLegal />
              </LegalPage>
            }
          />
          <Route
            path="/politica-privacidad"
            element={
              <LegalPage>
                <PoliticaPrivacidad />
              </LegalPage>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
